import { TListingRoadblockConfiguration } from "../listingRoadblockTypesAndCodecs";

export const WinInstruction: TListingRoadblockConfiguration = {
    type: "win_instruction",
    display_name: "Win instruction",
    only_create_if_resolved: [],
    create: {
        create_condition_description: "A valuation has been booked or sent",
        predicate: (d) =>
            d.listing.valuation_date !== null
            || d.listing.valuation_sent !== null,
    },
    checklist: [
        {
            type: "valuation_sent",
            is_resolved_by_short_description: "Valuation sent",
            resolved_by_party: "us",
            create: {
                create_condition_description: "Always",
                predicate: () => true,
            },
            resolve: {
                is_resolved_by_long_description: "The valuation has been sent to the seller",
                // Going live supersedes the question: the property is advertised, so
                // chasing whether a valuation was sent cannot be actioned. Instruction
                // alone deliberately does NOT resolve it — winning without a recorded
                // valuation is a process gap the board should keep showing.
                predicate: (d) =>
                    d.listing.valuation_sent !== null
                    || d.listing.live_date !== null,
            },
        },
        {
            type: "instruction_won",
            is_resolved_by_short_description: "Instruction won",
            resolved_by_party: "seller",
            create: {
                create_condition_description: "Always",
                predicate: () => true,
            },
            resolve: {
                is_resolved_by_long_description: "The seller has instructed us",
                predicate: (d) => d.listing.instructed_date !== null,
            },
        },
    ],
};
